import { useState } from 'react';
import { Check } from 'lucide-react';
import { Field } from '../components/ui/Field';
import { Button } from '../components/ui/Button';

const blank = (empresas) => ({
  empresa_id: empresas?.[0]?.id || '',
  nome: '',
  logo_url: '',
});

export function UnidadeNegocioForm({ initial, empresas, onSubmit, onCancel }) {
  const [form, setForm] = useState(initial || blank(empresas));
  const [errors, setErrors] = useState({});

  const update = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSubmit = () => {
    const e = {};
    if (!form.nome.trim()) e.nome = 'Obrigatório';
    if (!form.empresa_id) e.empresa_id = 'Selecione a empresa';
    setErrors(e);
    if (Object.keys(e).length === 0) onSubmit(form);
  };

  return (
    <div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
        <Field label="Empresa (mãe)" required error={errors.empresa_id}>
          <select className={`select ${errors.empresa_id ? 'error' : ''}`}
            value={form.empresa_id} onChange={e => update('empresa_id', e.target.value)}>
            <option value="">Selecione…</option>
            {(empresas || []).map(emp => (
              <option key={emp.id} value={emp.id}>
                {emp.nome_fantasia || emp.razao_social}
              </option>
            ))}
          </select>
        </Field>
        <Field label="Nome da unidade" required error={errors.nome}>
          <input className={`input ${errors.nome ? 'error' : ''}`}
            value={form.nome}
            onChange={e => update('nome', e.target.value)}
            placeholder="ex: CORBAN, CRO, …" />
        </Field>

        <Field label="Logo da unidade"
          helper="ID do Google Drive (público) ou URL completa. Usada no PDF do espelho desta unidade."
          className="col-span-2">
          <input className="input" value={form.logo_url || ''}
            placeholder="ID do Google Drive (ex: 1hgrsU_DQ4...) ou URL completa"
            onChange={e => update('logo_url', e.target.value)} />
        </Field>
      </div>

      <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 22 }}>
        <Button variant="secondary" onClick={onCancel}>Cancelar</Button>
        <Button onClick={handleSubmit} icon={Check}>Salvar</Button>
      </div>
    </div>
  );
}
